module.exports = {
  PROJECT_ID: {
    TEST: 'TEST-7KZ-57W-W86Z',
    PROD: '6KZ-57W-W86Z',
  },
  REGION: 'aps3',
};
